<template>
  <div>
    <h1>Webareal Callback</h1>
  </div>
</template>

<script setup lang="ts">
// import { useToast } from '@/composables/toast';
// import { onMounted } from 'vue';
// import * as Sentry from '@sentry/vue';
// import { STATE_KEY } from './webareal';
// import { useApi } from '@/composables/api';

// const { showToast } = useToast();
// const api = useApi();

// onMounted(async () => {
//   const urlParams = new URLSearchParams(window.location.search);
//   const code = urlParams.get('code');
//   const state = urlParams.get('state');

//   if (!code || !state) {
//     showToast('error', 'Failed to login to Webareal.');
//     Sentry.captureException(new Error('Failed to login to Webareal, empty code or state'));
//     return;
//   }

//   if (state !== localStorage.getItem(STATE_KEY)) {
//     showToast('error', 'Failed to login to Webareal.');
//     Sentry.captureException(new Error('Failed to login to Webareal, invalid state'));
//     return;
//   }
//   localStorage.removeItem(STATE_KEY);

//   const res = await api.get(
//     '/integrations/webareal/stores?code=' +
//       code +
//       '&redirect_uri=' +
//       window.location.origin +
//       '/integrations/webareal/callback',
//   );
//   console.log(res);
// });
</script>
